import React, { useContext, useEffect, useState, useMemo, useCallback } from 'react';
import { TableSectionV2 } from 'components/UI';
import localization from 'assets/localization/localization';
import { BaseUrl } from '../../../contexts/baseUrl/baseUrl';
import Layout from '../../../components/sales/layout/layout';
import moment from 'moment';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';

const cell = (val) => (val != null && val !== '' ? String(val) : '—');

const PendingListing = ({
  userRequestPendingList = [],
  approvalPendingRequest,
  userRequestFilter,
  filterDetails = [],
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [filterData, setFilterData] = useState(null);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await userRequestPendingList('1,4');
      setIsLoading(false);
    })();
  }, []);

  const buildRowActions = useCallback(
    (row) => [
      {
        name: 'View',
        link: `${baseUrl}/request-view/${row.id}`,
      },
    ],
    [baseUrl]
  );

  const tableColumns = useMemo(
    () => [
      { key: 'request_id', label: 'Request Id', format: (val) => cell(val) },
      { key: 'request_name', label: 'Requester Name', format: (val) => cell(val) },
      {
        key: 'requested_date',
        label: 'Requested Date',
        format: (val) => {
          if (!val) return '—';
          const formatted = moment(val).format('DD-MMMM-YYYY');
          return formatted === 'Invalid date' ? '—' : formatted;
        },
      },
      { key: 'use_case_name', label: 'Finance use case', format: (val) => cell(val) },
      { key: 'a1_approval_name', label: 'Approver L1', format: (val) => cell(val) },
      { key: 'a2_approval_name', label: 'Approver L2', format: (val) => cell(val) },
      { key: 'PI_no', label: 'PI', format: (val) => cell(val) },
      { key: 'TI_no', label: 'TI', format: (val) => cell(val) },
      { key: 'status', label: 'Request Status', format: (val) => cell(val) },
      { key: 'finance_approval_name', label: 'Finance acted by', format: (val) => cell(val) },
      {
        key: 'actions',
        label: 'Actions',
        getActions: (row) => buildRowActions(row),
      },
    ],
    [buildRowActions]
  );

  const onPageChange = async (val) => {
    setIsLoading(true);
    await userRequestPendingList('1,4', val.selected + 1);
    setIsLoading(false);
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (appliedFilterData) => {
    localStorage.setItem('help_desk_appr_reject', JSON.stringify(appliedFilterData));
    setListData([]);
    setIsLoading(true);
    setFilterData(appliedFilterData);
    await userRequestPendingList('1,4', 1, appliedFilterData);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    if (
      approvalPendingRequest &&
      approvalPendingRequest !== [] &&
      approvalPendingRequest.data !== undefined &&
      approvalPendingRequest.data.length > 0
    ) {
      setListData(approvalPendingRequest.data);
      setPageCount(Math.ceil(approvalPendingRequest.total / approvalPendingRequest.per_page));
      approvalPendingRequest.current_page && setCurrentPage(approvalPendingRequest.current_page);
    } else if (approvalPendingRequest?.data !== undefined) {
      setListData([]);
      setPageCount(0);
    }
  }, [approvalPendingRequest]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      setListData([]);
      const getFilter = await JSON.parse(localStorage.getItem('help_desk_appr_reject'));
      var page = localStorage.getItem('page');
      if (page !== undefined && page !== '' && page !== null) {
        localStorage.setItem('page', '');
        if (getFilter !== {}) {
          await userRequestPendingList('1,4', page, getFilter);
        } else {
          await userRequestPendingList('1,4', page, null);
        }
      } else {
        if (getFilter !== {}) {
          await userRequestPendingList('1,4', 1, getFilter);
        } else {
          await userRequestPendingList('1,4', 1, null);
        }
      }
      await userRequestFilter();
      setIsLoading(false);
    })();
  }, []);

  const srNo =
    approvalPendingRequest?.from ??
    (approvalPendingRequest?.current_page && approvalPendingRequest?.per_page
      ? (approvalPendingRequest.current_page - 1) * approvalPendingRequest.per_page + 1
      : 1);

  const headerBtns = () => {
    return (
      <Button onClick={filterToggle} className="filter-hamburger show-btn btn btn-transparent">
        {' '}
        <img src={Images?.Filter} alt="" />
        {localization.showFilters}
      </Button>
    );
  };

  return (
    <Layout
      title={localization.userRequest}
      isLoading={isLoading}
      isGoback={true}
      useNewHeaderLayout
      Buttons={headerBtns}
    >
      <TableSectionV2
        hideHeader
        hideTitleAndStatusFilter
        className="site-dashboard-table-section"
        tableData={listData}
        tableColumns={tableColumns}
        tableSectionProps={{ srNo }}
        pageCount={pageCount}
        currentPage={currentPage}
        onPageChange={onPageChange}
        isLoading={isLoading}
        emptyMessage="No requests found."
      />
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        listFilterData={filterDetails}
        helpdeskFilter={true}
        localstorageKey={'help_desk_appr_reject'}
      />
    </Layout>
  );
};

export default PendingListing;
